import useDeleteOnboardingItems from './useDeleteOnboardingItems';

export default useDeleteOnboardingItems;
export * from './useDeleteOnboardingItems';
